module.exports = __webpack_public_path__ + "img/28.89c7d7ad.png";